import { render, staticRenderFns } from "./TenderActionsList.vue?vue&type=template&id=0a47732f"
import script from "./TenderActionsList.vue?vue&type=script&lang=js"
export * from "./TenderActionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports